import type { ChartPanelId } from "@/vybe-trader-client/chart/stores/chartPanelTypes";
import type { TimeFrame } from "@/vybe-trader-client/chart/types";

/** Bump when the stored shape changes — older records are discarded, not migrated. */
export const CHART_DESK_VERSION = 1;

/** What one chart panel was showing when the app was last used. */
export interface ChartDeskSlot {
  /** Symbol currency (e.g. "EURUSD") — resolved back to a Symbol on restore. */
  symbol: string;
  timeframe: TimeFrame;
}

/**
 * Proposal 74 — the "chart desk": which symbol and timeframe sat in each panel.
 * Device-local only; scoped to one trading account (symbol universes differ per
 * gateway, so a snapshot must never be replayed against a different account).
 */
export interface ChartDeskSnapshot {
  v: number;
  /** `${companyName}_${serverName}_${login}` of the account that owned this desk. */
  accountKey: string;
  slots: Partial<Record<ChartPanelId, ChartDeskSlot>>;
}
